module.exports = __webpack_public_path__ + "static/media/nathan.9bb8e616.png";